<template>
  <div id="app">
    <router-view />
  </div>
</template>

<script>
export default {
  name: 'App'
}
</script>

<style>
html, body, #app {
  height: 100%;
  margin: 0;
  padding: 0;
  font-family: 'PingFang SC', 'Microsoft YaHei', 'Helvetica Neue', sans-serif;
}

/* ====== 页面路由过渡动画 ====== */
.page-fade-enter-active,
.page-fade-leave-active {
  transition: opacity 0.25s ease, transform 0.25s ease;
}
.page-fade-enter {
  opacity: 0;
  transform: translateY(12px);
}
.page-fade-leave-to {
  opacity: 0;
  transform: translateY(-6px);
}

/* ====== 全局 el-dialog 过渡动画覆盖 ====== */
.el-dialog {
  animation: dialogIn 0.35s cubic-bezier(0.25, 0.8, 0.25, 1.2);
}

@keyframes dialogIn {
  from {
    opacity: 0;
    transform: scale(0.92) translateY(-24px);
  }
  to {
    opacity: 1;
    transform: scale(1) translateY(0);
  }
}

/* ====== el-message-box 过渡 ====== */
.el-message-box {
  animation: msgBoxIn 0.3s cubic-bezier(0.25, 0.8, 0.25, 1.2);
}

@keyframes msgBoxIn {
  from {
    opacity: 0;
    transform: scale(0.9) translateY(-16px);
  }
  to {
    opacity: 1;
    transform: scale(1) translateY(0);
  }
}

/* ====== 全局滚动条美化 ====== */
::-webkit-scrollbar {
  width: 6px;
  height: 6px;
}

::-webkit-scrollbar-track {
  background: transparent;
}

::-webkit-scrollbar-thumb {
  background: #c8d0e0;
  border-radius: 3px;
}

::-webkit-scrollbar-thumb:hover {
  background: #a0aac0;
}
</style>
